import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { CAMPAIGN_ALL_LINK } from "../../constants/constants";
import Header from "../Header";
import Footer from "../Footer";
import Sidebar from "../Sidebar";
import Tabs from "./Tabs";
import { notifyError, notifySuccess,notifyInfo } from "../../helper";
import client from "../../api";
import ScheduleLaterCampaignModelWindow from "./models/ScheduleLaterCampaignModelWindow";

const FinalStepForCampaign = () => {
    const api = client();
    const {campaignID} = useParams('');
    const [campaignOverview, setCampaignOverview] = useState({});
    const [loading,setLoading] = useState(false);
    const [loading2,setLoading2] = useState(false);
    const [loading3,setLoading3] = useState(false);
    const [toggleModelWindow, setToggleModelWindow] = useState(false);
    
    const changeCampaignStatus = async (type) => {
        const currentStatus = Object.keys(campaignOverview).length ? campaignOverview.status : '';
        if(currentStatus === type){
            notifyInfo(`This campaign is already in ${currentStatus} state`);
            return;
        }
        try{
            if(type === 'started') setLoading(true);
            if(type === 'paused') setLoading2(true);
            const response = await api.post('/v1/campaign/status/update',{
                campaigns_id:[campaignID],
                status: type,
            });

            if(response.status === 200 || response.status === 201){
                if(type === 'started') setLoading(false);
                if(type === 'paused') setLoading2(false);
                notifySuccess('Campaign Status updated successfully');
                setTimeout(()=>{
                    window.location.href = CAMPAIGN_ALL_LINK;
                },2000);
            }

        } catch(error){
            console.log('error.message',error);
            if(type === 'started') setLoading(false);
            if(type === 'paused') setLoading2(false);
            if(error.status) notifyError('Bad Request. Not able to change campaign status');
        }
    }
    useEffect(()=>{
        
        const getCampaignPreview = async () => {
            try{
                const response = await api.post('/v1/campaign/preview',{ campaign_id:campaignID });
                if(response.status === 200 ||response.status === 201 ){
                    setCampaignOverview(response.data.campaignPreview);
                }
            } catch(error){
                console.log('error.message',error);
                if(error.status === 400) notifyError('Bad Request. Not able to fetch Campaign Overview');
            }
        }
        if(!Object.keys(campaignOverview).length)
            getCampaignPreview();
    });
    
    return(<>
        <Header/>
        <div className="main-page">
            <Sidebar/>
           <div className="campaign-create-steps">
            <div className="top-section">
                <h1>Add Campaign </h1>                
            </div>
                <div className="steps-wrap">
                    <Tabs currentTab="send" completedTabs={campaignOverview.completed_tab} />
                    
                    <div className="send-step">
                        <h3>Are you ready to start your campaign?</h3>
                        <div className="btn-wrap">
                            <button 
                                className={loading ? "next-btn start-camp-btn button--loading":"next-btn start-camp-btn"}
                                disabled={loading}
                                onClick={()=>{
                                    changeCampaignStatus('started')
                                }}><span className="button--text">Start Campaign <i className="bx bx-caret-right"></i></span>
                            </button>
                            <button 
                                className={loading2 ? "pause-btn button--loading":"pause-btn"} 
                                disabled={loading2}
                                onClick={()=>{
                                    changeCampaignStatus('paused')
                                }}><span className="button--text">Pause Campaign <i className="bx bx-pause"></i></span>
                            </button>
                            <button 
                                className={"schedule-btn"}
                                onClick={()=>{
                                    setToggleModelWindow(!toggleModelWindow)
                                }}><span className="button--text">Schedule Later <i className='bx bx-time-five'></i></span>
                            </button>
                        </div>
                        <div className="msg-box-wrap">
                            <div className="msgbox">
                                <h2> From Address</h2>
                                <div className="text-wrap">
                                    <div className="from-emails">
                                        <span className="title-s">Sending Account</span>
                                        <span className="value-s">{Object.keys(campaignOverview).length ? campaignOverview.assigned_to_user.email:''}</span>
                                    </div>
                                </div>
                                <div className="text-wrap">
                                    <div className="from-emails">
                                        <span className="title-s">Sending Account Name</span>
                                        <span className="value-s">{Object.keys(campaignOverview).length ? campaignOverview.assigned_to_user.name:''}</span>
                                    </div>
                                </div>
                            </div>

                            <div className="msgbox">
                                <h2>Recipients</h2>
                                
                                <div className="text-wrap">
                                    <div className="recipients-count">{Object.keys(campaignOverview).length ? campaignOverview?.contacts_data?.contacts_list.length:''} recipients will be sent campaign email immediately</div>
                                    <ul>
                                        {Object.keys(campaignOverview).length ? campaignOverview?.contacts_data?.contacts_list.map((contact,i)=>(<li key={i}>{contact.email}</li>)):''}
                                    </ul>
                                </div>                                
                            </div>

                            <div className="msgbox">
                                <h2> Messages </h2>
                                {Object.keys(campaignOverview).length ? (campaignOverview.steps).map((message,i)=>(
                                    <div className="sending-msg-details" key={i}>
                                        {i === 0 ? <span className="campaign-message-schedule"><i className="bx bx-envelope"></i>Initial Email</span> : ''}
                                        {i !== 0 ? <span className="campaign-message-schedule"><i className="bx bx-undo"></i> Follow-up {message.minimum_delay_after_last_send} {message.minimum_delay_after_last_send < 2 ? 'day':'days'}  later</span> : ''}
                                        <div className="message-subject">{message.subject}</div>
                                        {campaignOverview?.message_mime_type === 'text/plain'? <pre className="pre-msj"><div className="message-text" dangerouslySetInnerHTML={{__html:message.body}}></div></pre>:<div className="message-text" dangerouslySetInnerHTML={{__html:message.body}}></div>}
                                    </div>
                                    )):''}                                
                            </div>
                        </div>
                    </div>
                </div>
           </div>            
        </div>
        {toggleModelWindow && <ScheduleLaterCampaignModelWindow
            setToggleModelWindow = { setToggleModelWindow }
            toggleModelWindow = { toggleModelWindow }            
        />}
        <Footer/>
    </>);
}

export default FinalStepForCampaign;